import { withBemMod } from '@bem-react/core';
import { cnCheckbox } from '../Checkbox';
import './Checkbox_indeterminate.css';
/**
 * Модификатор, отвечающий за промежуточное состояние переключателя. Используется в дереве переключателей.
 * @param {ICheckboxIndeterminateProps} props
 */
export var withIndeterminate = withBemMod(cnCheckbox(), { indeterminate: true });
